import type { SxStyle } from '@aibees/shared/theme';

export const wrapper: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1.5,
  flex: 1,
  minHeight: 0,
};

export const headRow: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 1,
};

export const inclusionList: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  mt: 1,
};

export const group: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
};

export const groupHeader: SxStyle = {
  mb: 0.5,
};

export const inclusionRow: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
};

export const compareSlot: SxStyle = {
  mt: 'auto',
  display: 'flex',
  flexDirection: 'column',
  gap: 1.5,
};
